export const WordIcon: React.FC<{ color?: string; size?: number }> = ({
  size = 40,
  color = "#4586F9",
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M23.172 0C23.7022 0 24.2107 0.210507 24.5857 0.585255L36.4137 12.4044C36.7891 12.7795 37 13.2884 37 13.8191V35.3333C37 37.9107 34.8689 40 32.24 40H7.76C5.13112 40 3 37.9107 3 35.3333V4.66667C3 2.08934 5.13112 0 7.76 0H23.172Z"
      fill={color}
    />
    <g filter="url(#filter0_d_word)">
      <path
        d="M35.1548 12.1381C35.4678 12.4537 35.2443 12.9902 34.7998 12.9902H29C26.4227 12.9902 24.0976 10.7233 24.0976 8.21031V2.20435C24.0976 1.75791 24.6382 1.53528 24.9526 1.85224L35.1548 12.1381Z"
        fill="white"
        fillOpacity="0.24"
        shapeRendering="crispEdges"
      />
    </g>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 16.9902H24V18.7402H10V16.9902ZM10 20.4902H24V22.2402H10V20.4902ZM10 23.9902H24V25.7402H10V23.9902ZM10 27.4902H17V29.2402H10V27.4902Z"
      fill="white"
    />
    <defs>
      <filter
        id="filter0_d_word"
        x="22.0977"
        y="1.70337"
        width="15.2031"
        height="15.2869"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.04 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_word"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_word"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);
